import { USER_TYPE } from '@/constants'
import store from '@/store'
import Vue from 'vue'

export const sendLocalCartItemsToApi = async () => {
  const currentUser = store.state.user.currentUser

  if (currentUser.user_type !== USER_TYPE.BUYER) {
    return
  }

  try {
    const { results: currentApiCartItems } = await Vue.$http.get('/cart/items/', {})
    const currentApiCartProductMap = new Map()

    currentApiCartItems
      .flatMap(item => item.products)
      .forEach(product => {
        currentApiCartProductMap.set(product.seller_product.id, product.id)
      })

    const localCartItems = store.state.localCart.localCartItems || JSON.parse(localStorage.getItem('localCart')) || []
    const products = localCartItems.flatMap(item => item.products)

    for (const product of products) {
      try {
        // Если у юзера уже был добавлен в корзину этот товар (когда был залогинен)
        // обновляем вес согласно тому который он указал добавив товар в корзину до/без авторизации
        if (currentApiCartProductMap.has(product.id)) {
          await store.dispatch('cart/editCartProduct', {
            product_id: currentApiCartProductMap.get(product.id),
            weight: product.weight,
          })
        } else {
          // Если товар не был добавлен ранее, просто переносим его из локальной корзины в серверную
          await store.dispatch('cart/addToCart', {
            seller_product: product.id,
            weight: product.weight,
          })
        }
      } catch (e) {
        console.error(e)
      }
    }

    store.commit('localCart/setLocalCartItems', [])
  } catch (e) {
    console.error(e)
  }
}
